import BasePerimeter from '@/kindergarten/perimeters/BasePerimiter';

export default new BasePerimeter({
  purpose: 'auth',

  can: {
    route() {
      return this.child && (this.isAdmin() || this.isVertrieb());
    },
  },
});



// WEBPACK FOOTER //
// ./src/kindergarten/perimeters/VertriebPerimeter.js